var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('th',{staticClass:"table-header-atom",attrs:{"scope":"col"}},[_c('EsyParagraph',[_c('strong',[_vm._v(" "+_vm._s(_vm.content)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }